<script setup>
  import FieldValueRenderer from '@/features/settingsManagement/fieldManagement/edit/plugin/FieldValueRenderer.vue'
  import { fieldCommonProps } from '@/features/settingsManagement/fieldManagement/edit/utils/fieldUtils.js'

  defineProps({
    modelValue: fieldCommonProps.modelValue,
    field: fieldCommonProps.field,
  })
</script>

<template>
  <FieldValueRenderer :field="field">
    <template #label> {{ field.key }} </template>

    {{ modelValue }}
  </FieldValueRenderer>
</template>

<style lang="scss" scoped></style>
